import * as React from 'react';
import { connect } from 'react-redux';
import {
  StepWizardHost
} from 'sos-common/js/components/WizardStepper/WizzardStepperHost';
import { MessageBanner } from 'sos-common/js/components/MessageBanner/messageBanner';
import { FormWrapper } from 'sos-eservice-common/js/components/FormWrapper/FromWrapper';
import { StepValidationMap } from 'sos-common/js/commonTypes/validation.types';
import { StatisticsOrderStore } from '../../models/StatisticsOrderStore.types';
import { closeMessageBar, setCurrentStep } from 'sos-eservice-common/js/Redux/Actions';
import { WizardHostStat } from 'sos-common/js/components/WizardStepper/WizardStepper.types';
import { StepOne, StepTwo, StepThree } from './steps';

export interface StatisticsOrderFormProps {
  stepValidationMap: StepValidationMap;
  showSavedBanner: boolean;
  closeMessageBar: typeof closeMessageBar;
  setCurrentStep: typeof setCurrentStep;
}

class StatisticsOrderForm extends React.Component<
  StatisticsOrderFormProps,
  {}
> {
  public onCloseMessageBar = () => {
    this.props.closeMessageBar();
  }

  public handleStepChange = (stat: WizardHostStat) => {
    this.props.setCurrentStep(stat);
  }
  public render() {
    // todo: Set translation for mheading on FormWrapper
    return (
      <React.Fragment>
        {this.props.showSavedBanner && (
          <MessageBanner onClose={this.onCloseMessageBar} />
        )}
        <FormWrapper heading='Beställning av statistik'>
          <StepWizardHost
            onStepChange={this.handleStepChange}
            stepValidationMap={this.props.stepValidationMap}
            nextLabel='Nästa steg'
            previousLabel='Föregående steg'
            classNamesForFocusInput='step animated'
          >
            {}
            <StepOne />
            <StepTwo />
            <StepThree />
          </StepWizardHost>
        </FormWrapper>
      </React.Fragment>
    );
  }
}

const mapState2Props = (state: StatisticsOrderStore) => {
  return {
    stepValidationMap: state.validationState.stepValidationMap,
    showSavedBanner: state.globals.showSavedBanner
  } as StatisticsOrderFormProps;
};

const mapDispatch2Props = {
  closeMessageBar,
  setCurrentStep
};

export default connect(
  mapState2Props,
  mapDispatch2Props
)(StatisticsOrderForm);
